//import FuseLoadable
import { FuseLoadable } from "@fuse";
//export ImplementationConfig
export const BankRecPanelConfig = {
  //settings
  settings: {
    //set layout
    layout: {
      //set config as empty object
      config: {}
    }
  },
  //set routes
  routes: [
    {
      path     : '/app/bankRec/panel',
      component: FuseLoadable({
          loader: () => import('./BankRecForm')
      })
  }
  ]
  //end routes
};
